var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2989995 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9425",
    d: "M1.96759 7.75733L11.5751 7.76171L9.7806 9.55945C9.6747 9.66247 9.61491 9.80395 9.61491 9.9517C9.61905 10.4392 10.2103 10.6786 10.5522 10.3311L13.2906 7.59605C13.5049 7.38222 13.5049 7.03499 13.2906 6.82116L10.5522 4.08608C10.035 3.55042 9.24208 4.34774 9.7806 4.86203L11.5858 6.66725L1.96758 6.66287C1.6591 6.65738 1.40708 6.90799 1.41018 7.21651C1.41225 7.52043 1.66371 7.76325 1.96759 7.75733Z",
    fill: "#4285F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.6e2f090e5152a33044ce45f030910b85.svg";
export { ForwardRef as ReactComponent };